import { Expose } from "class-transformer";
import { ProfileMigrationStateEnum } from "../../constants/profile-migration-state.enum";

export class ProfileMigration {
  @Expose()
  migrationState!: ProfileMigrationStateEnum;

  @Expose()
  message!: string;

  @Expose()
  startedAt!: string | null;

  @Expose()
  completedAt!: string | null;

  get isMigrationInProgress(): boolean {
    return this.migrationState === ProfileMigrationStateEnum.IN_PROGRESS;
  }

  get isMigrationCompleted(): boolean {
    return this.migrationState === ProfileMigrationStateEnum.COMPLETED;
  }

  get isMigrationNotNeeded(): boolean {
    return this.migrationState === ProfileMigrationStateEnum.NOT_NEEDED;
  }
}
